enum BrakeType {
  DISC = 'DISC',
  DRUM = 'DRUM',
  NO_BRAKES = 'NOBRAKES',
}

export default BrakeType;